export default function stringToParagraphs(str: string): string[] {
  const paragraphMarker = /\n\n{1,}/;
  return str.split(paragraphMarker)
}